var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 960,
    height: 726.757,
    viewBox: "0 0 960 726.757",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-595 -247.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.856,713.565l-.572-.167a92.5,92.5,0,0,1,23.289-38.746l.4.442a91.873,91.873,0,0,0-23.117,38.471Z",
    transform: "translate(379.483 222.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970,767.236H753.8l-.041-1.211L743.436,470.778H980.365Zm-213.775-2.511h211.35l10.19-291.436H746.035Z",
    transform: "translate(370.401 205.822)",
    fill: "#EA7171"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1159.33 731.305)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.445,
    height: 203.497,
    transform: "translate(0 0)",
    fill: "#EA7171"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.445,
    height: 203.497,
    transform: "translate(64.749 0)",
    fill: "#EA7171"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.445,
    height: 203.497,
    transform: "translate(129.498 0)",
    fill: "#EA7171"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1096.448,582l-1.062-.671L826.838,411.621l23.295-36.861,1.062.671,268.548,169.709ZM830.3,410.84l265.364,167.7,20.611-32.615-265.363-167.7Z",
    transform: "translate(391.702 181.299)",
    fill: "#EA7171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.026,394.749a48.282,48.282,0,0,0-73.592,47.793l12.805,8.092a38.094,38.094,0,1,1,36.381,23l12.805,8.092a48.282,48.282,0,0,0,11.611-86.978Z",
    transform: "translate(418.286 184.493)",
    fill: "#EA7171"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 2.511,
    transform: "translate(595 971.326)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(993.638 465.177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M709.92,553.736l105.456-73.909a4.529,4.529,0,0,0,1.107-6.3l-82.771-118.1a4.529,4.529,0,0,0-6.3-1.107L621.961,428.234a4.529,4.529,0,0,0-1.107,6.3l82.769,118.1A4.529,4.529,0,0,0,709.92,553.736Z",
    transform: "translate(-620.038 -353.509)",
    fill: "#21376c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.387,460.406l61.88-43.369a6.654,6.654,0,0,0-7.638-10.9l-61.88,43.369a6.654,6.654,0,0,0,7.638,10.9Z",
    transform: "translate(-617.221 -340.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.075,476.547l61.88-43.369a6.654,6.654,0,0,0-7.638-10.9l-61.88,43.369a6.654,6.654,0,1,0,7.638,10.9Z",
    transform: "translate(-591.707 -336.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.641,492.861l61.88-43.369a6.654,6.654,0,0,0-7.638-10.9L653,481.963a6.654,6.654,0,1,0,7.638,10.9Z",
    transform: "translate(-565.919 -332.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.447,423.07l23.968-16.8a6.654,6.654,0,1,0-7.638-10.9l-23.968,16.8a6.654,6.654,0,1,0,7.638,10.9Z",
    transform: "translate(-647.107 -343.125)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(680.368 247.079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.953,88.776l9.734-18.939a38.247,38.247,0,1,1,29.058,5.914L40.6,94.323Z",
    transform: "translate(154.663 16.5)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.059,
    height: 25.25,
    transform: "matrix(0.799, 0.602, -0.602, 0.799, 32.162, 642.431)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 25.159,
    height: 26.405,
    transform: "translate(190.851 675.548)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.44,624.791h56.131a32.374,32.374,0,0,0,13.947-3.177l10.348-4.973a6.214,6.214,0,0,0-1.035-11.59l-21.347-5.907-36.526-19.2-.028.138c-.683,3.459-1.741,8.684-1.873,9-3.746,4.291-7.593,6.268-11.435,5.877-6.7-.68-11.158-8.419-11.2-8.5l-.033-.06-.069.008a4.445,4.445,0,0,0-3.45,1.882c-1.53,2.306-.6,5.856-.443,6.392-1.832,1.791-2.656,11.8-2.716,12.608-2.648,2.806-3.906,5.5-3.746,8.019a8.633,8.633,0,0,0,3.621,6.068,15.676,15.676,0,0,0,9.851,3.411Z",
    transform: "translate(-220.081 101.183)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.242,301.607s-11.269-8.634-11.269,12.454l-1.779,69.688,19.868,65.833,11.566-21.351-4.745-46.261Z",
    transform: "translate(-349.117 -124.781)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.1,458.967S609.17,522.6,592.618,574.83l-8.925,194.405-33.759,3.78L538.171,624.049,526.846,550l-23.521,67.519L425.793,760.383l-35.717-27.876s39.58-108,68.82-130.672l14.665-167.026Z",
    transform: "translate(-363.435 -91.533)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.838,221.247c4.585.6,8.042-4.1,9.646-8.43s2.826-9.383,6.812-11.725c5.446-3.2,12.412.649,18.64-.407,7.032-1.192,11.6-8.645,11.963-15.768s-2.476-13.975-5.258-20.542l-.971,8.162a16.187,16.187,0,0,0-7.073-14.148l1.252,11.977a12.712,12.712,0,0,0-14.624-10.515l.2,7.136c-8.122-.966-16.315-1.933-24.462-1.2s-16.349,3.313-22.523,8.678c-9.236,8.025-12.608,21.24-11.476,33.427s6.161,23.627,11.4,34.682c1.318,2.782,3.142,5.921,6.2,6.275,2.747.319,5.262-1.978,6.115-4.609a16.7,16.7,0,0,0-.074-8.207c-.775-4.106-1.747-8.3-1.021-12.418s3.687-8.181,7.834-8.686,8.392,4.237,6.4,7.909Z",
    transform: "translate(-338.632 -158.388)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.009,318.954l-127.652-8.236,9.609-39.805,116.67,26.08Z",
    transform: "translate(-219.975 65.497)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.206,278l-20.588-.443L48.88,262.451l-8.31,14.788-20.11-.428L0,264.947l20.162-61.68,6.526-56.339L16.6,93.854S3.914,45.11,52.78,18.827l14.827-7.711L75.612,0s8.951,3.042,32.915,14.972l1.7,10.416L118,73.211l36.77,58.281,22.765,17.167a7.665,7.665,0,0,1,3.262,8.157l-3.333,14.127a7.665,7.665,0,0,1-2.325,3.926,7.517,7.517,0,0,1-1.459,1.033v0a7.643,7.643,0,0,1-6.215.493l-29.527-5.872q-2.227-.79-4.393-1.707l18.284,112.456Z",
    transform: "translate(88.705 94.537)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.084,408.576a13.07,13.07,0,0,1-16.254-11.726s-63.549-5.961-67.487-16.74,10.991-23.139,10.991-23.139l69.516,25.7a13.141,13.141,0,0,1,3.234,25.9Z",
    transform: "translate(-304.288 -111.728)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43,39.963,52.315,72.276a31.008,31.008,0,0,0,12.479,5.6l10.771,2.154a5.946,5.946,0,0,0,5.882-9.451l-12.906-16.8L51.684,18.086l-.1.09c-2.513,2.25-6.326,5.633-6.615,5.8-5.33,1.122-9.408.418-12.12-2.093C28.125,17.51,29.171,9.029,29.181,8.943l.01-.064-.054-.034a4.256,4.256,0,0,0-3.721-.55c-2.5.881-3.826,4.13-4.019,4.629-2.432.314-8.82,7.485-9.331,8.066-3.641.623-6.155,1.961-7.48,3.975a8.261,8.261,0,0,0-.728,6.723,15,15,0,0,0,5.558,8.276Z",
    transform: "translate(-3.455 644.201)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c5d439fe26ccc7d455f8a1c6532ee300.svg";
export { ForwardRef as ReactComponent };